import { LAYOUTS, } from '@voltmoney/types';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { onChangeDimension, onChangeInput, onGoBack } from "./actions";
import { getOTP } from "../checkLimitMFC_init/actions";
import sharedPropsService from "../../SharedPropsService";
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
export const template = async (phoneNumber, verifyOtpData, leadId) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_MFC_OTP,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'CheckLimitMFCOtpRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitMFCOtpRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: _isMobile ? StackAlignItems.flexStart : StackAlignItems.center,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                bottom: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL
            },
            widgetItems: [
                { id: 'CheckLimitMFCOtpRootStackT1', type: WIDGET.TEXT },
                { id: 'CheckLimitMFCOtpRootStackSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitMFCOtpRootStackS1', type: WIDGET.STACK },
                { id: 'CheckLimitMFCOtpRootStackSpace1', type: WIDGET.SPACE },
                { id: 'otpModalScreen', type: WIDGET.OTP_MODAL_SCREEN },
                { id: 'CheckLimitMFCOtpRootStackSpace2', type: WIDGET.SPACE },
                { id: 'MfcentralStack', type: WIDGET.STACK }
            ],
            dimensionAction: {
                routeId: ROUTE.CHECK_LIMIT_MFC_OTP,
                type: ACTION.ON_CHANGE_DIMENSION,
                payload: {}
            }
        },
        MfcentralStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'MfcentralStackIcon1', type: WIDGET.ICON },
                { id: 'MfcentralStackSpace0', type: WIDGET.SPACE },
                { id: 'MfcentralStackT1', type: WIDGET.TEXT }
            ]
        },
        MfcentralStackT1: {
            label: 'Powered by MFCentral',
            fontSize: _isMobile ? FontSizeTokens.XXS : FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
        MfcentralStackIcon1: {
            name: IconTokens.VerifiedIcon1,
            size: IconSizeTokens.SM
        },
        MfcentralStackSpace0: {
            size: SizeTypeTokens.SM
        },
        otpModalScreen: {
            type: InputTypeToken.OTP,
            isFocus: true,
            title: "Enter OTP",
            resendTimer: 60,
            state: InputStateToken.DEFAULT,
            charLimit: 6,
            keyboardType: KeyboardTypeToken.numberPad,
            action: {
                type: ACTION.CHANGE_INPUT,
                routeId: ROUTE.CHECK_LIMIT_MFC_OTP,
                payload: {
                    value: "",
                    widgetId: "OtpInput",
                    verifyOtpData: verifyOtpData,
                    leadId: leadId,
                    isResend: false,
                },
            },
            otpAction: {
                type: ACTION.IS_RESEND_OTP,
                routeId: ROUTE.CHECK_LIMIT_MFC_OTP,
                payload: {
                    value: "",
                    widgetId: "OtpInput",
                    verifyOtpData: verifyOtpData,
                    leadId: leadId,
                    isResend: true,
                },
            },
        },
        CheckLimitMFCOtpRootStackT1: {
            label: 'MFCentral has sent an OTP',
            fontSize: _isMobile ? FontSizeTokens.MD : FontSizeTokens.LG,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            lineHeight: 24
        },
        CheckLimitMFCOtpRootStackS1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitMFCOtpRootStackS1T1', type: WIDGET.TEXT },
                { id: 'CheckLimitMFCOtpRootStackS1T2', type: WIDGET.TEXT },
                { id: 'CheckLimitMFCOtpRootStackS1T3_Edit', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_MFC_OTP,
                type: ACTION.GO_BACK,
                payload: {}
            }
        },
        CheckLimitMFCOtpRootStackS1T3_Edit: {
            label: '   Edit',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            lineHeight: 20,
            color: ColorTokens.Primary_100,
        },
        CheckLimitMFCOtpRootStackS1T2: {
            label: `${phoneNumber ? phoneNumber : ''}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal,
        },
        CheckLimitMFCOtpRootStackS1T1: {
            label: 'OTP sent to ',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 20,
            color: ColorTokens.Grey_Charcoal,
        },
        CheckLimitMFCOtpRootStackSpace0: {
            size: SizeTypeTokens.SM
        },
        CheckLimitMFCOtpRootStackSpace1: {
            size: SizeTypeTokens.Size32
        },
        CheckLimitMFCOtpRootStackSpace2: {
            size: SizeTypeTokens.Size80
        },
    }
});
export const CheckLimitMFCOtpMF = {
    onLoad: async (_, { phoneNumber, 
    // clientRefNo,
    // otpRef,
    // reqId,
    leadId, }) => {
        const MfCentralInitResponseData = await sharedPropsService.getMfCentralInitResponse();
        const verifyOtpData = {
            clientRefNo: MfCentralInitResponseData?.clientRefNo,
            otpRef: MfCentralInitResponseData?.otpRef,
            reqId: MfCentralInitResponseData?.reqId
        };
        return Promise.resolve(template(phoneNumber, verifyOtpData, leadId));
    },
    actions: {
        [ACTION.CHANGE_INPUT]: onChangeInput,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GO_BACK]: onGoBack,
        [ACTION.IS_RESEND_OTP]: getOTP
    },
};
